import React, { useCallback, useRef, useState } from 'react';
import { useGridFilter } from "ag-grid-react";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Tooltip } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { processDate } from '../../helper/dateHelper';

export function CustomDateFilter(params) {
    const [selectedValue, setSelectedValue] = useState("None")
    const [filterDate, setFilteredDate] = useState(null)
    const refInput = useRef(null);
    const { model, onModelChange, getValue, colDef } = params
    const doesFilterPass = useCallback((params) => {
        const { node } = params;
        const filterText = model?.filter?.[0]?.toLowerCase() || '';  // Get the filter text
        const value = getValue(node)?.toString()?.toLowerCase();
        const filteringCondition = model?.type ||selectedValue;
        const valueDate = value ? new Date(value).getTime() : null;
        const filteringDate = model?.filter?new Date(processDate(model?.filter?.[0]?.toLowerCase())).getTime():filterDate ? new Date(processDate(filterDate)).getTime() :null;

        switch (filteringCondition) {
            case 'blank':
                return value === null || value === undefined || value === '';
            case 'notBlank':
                return !(value === null || value === undefined || value === '');
            case 'equals':
                return valueDate === filteringDate;
            case 'notEqual':
                return valueDate !== filteringDate;
            case 'greaterThan':
                return valueDate !== null && value!==undefined&& value!==""&& valueDate > filteringDate;
            case 'isGreaterThanOrEqualTo':
                return valueDate !== null && value!==undefined&& value!==""&& valueDate >= filteringDate;
            case 'lessThan':
                return valueDate !== null && value!==undefined&& value!==""&& valueDate < filteringDate;
            case 'isLessThanOrEqualTo':
                return valueDate !== null && value!==undefined&& value!==""&& valueDate <= filteringDate;
            default:
                return true;
        }
    }, [model,filterDate]);

    const afterGuiAttached = useCallback((params) => {
        if (!params || !params.suppressFocus) {
            refInput.current.focus();
        }
    }, []);

    // register filter handlers with the grid
    useGridFilter({
        doesFilterPass,
        afterGuiAttached,
    });

    const handleMouseDown = (event) => {
        event.preventDefault();
        event.stopPropogation();
    };
    const handleApply = (e) => {
        onModelChange(selectedValue === '' ? null : selectedValue)
    }
    const handleClear = () => {
        setFilteredDate("");
        setSelectedValue("None")
        onModelChange(null)
    }
    return (
        <Box sx={{ maxHeight: "250px", overflowY: "auto" }}>
            <Box sx={{ margin: 0, padding: "0.5rem", display: 'flex', alignItems: "center", justifyContent: "center", width: "100%", gap: "0.5rem" }}>
                <FormControl size='small' sx={{ width: "100%" }}>
                    <select
                        ref={refInput}
                        value={selectedValue}
                        onChange={(e) => { setSelectedValue(e.target.value) }}
                    //onMouseDown={handleMouseDown}
                    >
                        <option value={"None"}>None</option>
                        <option value={"blank"}>is blank</option>
                        <option value={"notBlank"}>is not blank</option>
                        <option value={"equals"}>is equal to</option>
                        <option value={"notEqual"}>is not equal to</option>
                        <option value={"greaterThan"}>is greater than</option>
                        <option value={"isGreaterThanOrEqualTo"}>is greater than or equal to</option>
                        <option value={"lessThan"}>is less than</option>
                        <option value={"isLessThanOrEqualTo"}>is less than or equal to</option>
                    </select>
                </FormControl>
                <Tooltip title="Clear Filter">
                    <ClearIcon sx={{ fontSize: "1rem", cursor: "pointer" }} onClick={handleClear} />
                </Tooltip>
            </Box>
            {(selectedValue !== "isBlank" && selectedValue !== "isNotBlank" && selectedValue !== "None") && <Box sx={{ margin: 0, padding: "0.5rem", display: 'flex', alignItems: "center", justifyContent: "center", width: "100%" }}>

                <input
                    type="date"
                    value={filterDate}
                    onChange={(e) => setFilteredDate(e.target.value)}
                    placeholder="Select Date"
                    style={{ width: "100%", padding: "0.25rem" }}
                    disabled={selectedValue === "None"}
                    min="01/01/1900"
                    max="12/31/2099"
                />
            </Box>}
            <Box sx={{ padding: "0 1rem 0.5rem", width: "100%", display: 'flex', alignItems: "center", justifyContent: "flex-end", gap: "0.5rem" }}>
                <Button style={{ border: "1px solid #134157", background: "transparent", color: "#134157", fontWeight: "bold", borderRadius: "25px", fontSize: "0.5rem", padding: "3px 4px" }} onClick={handleClear}>Clear</Button>
                <Button style={{ border: "1px solid #134157", background: "transparent", color: "#134157", fontWeight: "bold", borderRadius: "25px", fontSize: "0.5rem", padding: "3px 4px" }} onClick={handleApply}>Apply</Button>
            </Box>
        </Box>
    )
};